// extracted by mini-css-extract-plugin
export default {"popup":"WIKmleCjTsdrx5uw8m6J","iconColor":"xS3BYwTtJCmsq4LzEQ8M","listItem":"HcNg9yjEOWAOeOIQSoDy"};